/**
 * Auth Layout Component
 * Layout for login/register pages
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import './AuthLayout.css';

const { Content } = Layout;
const { Title, Text } = Typography;

const AuthLayout: React.FC = () => {
  return (
    <Layout className="auth-layout">
      <Content className="auth-content">
        <div className="auth-header">
          <Title level={2} style={{ color: '#1890ff' }}>
            GCMM Business Management
          </Title>
          <Text type="secondary">
            Professional platform for general contractors
          </Text>
        </div>
        <div className="auth-form-container">
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;
